import React, { FC } from "react";

import { ApprovedIcon, CloseIcon } from "icons";
import { ButtonOutlined } from "styled";

import { Dialog } from "../styled";
import { DialogActions, DialogContent, DialogTitle } from "./styled";
import type { AdminModalProps } from "./typed";
import { LinearLoader } from "components";

export const AdminModal: FC<AdminModalProps> = ({
  children,
  isLoading,
  open,
  title,
  disabledApproveButton,
  cancelButton,
  approveButton,
  maxWidth,
  handleClose,
  handleConfirm,
}) => (
  <Dialog
    open={open}
    maxWidth="sm"
    maxWidthStyle={maxWidth}
    fullWidth
    onClose={!!handleClose && handleClose}
    onKeyUp={e => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleConfirm();
      }
    }}
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>

    <DialogActions>
      <ButtonOutlined startIcon={<CloseIcon />} onClick={handleClose}>
        {cancelButton}
      </ButtonOutlined>
      <ButtonOutlined
        startIcon={<ApprovedIcon />}
        onClick={handleConfirm}
        disabled={disabledApproveButton}
      >
        {approveButton}
      </ButtonOutlined>
    </DialogActions>
    {isLoading && <LinearLoader />}
  </Dialog>
);

AdminModal.defaultProps = {
  disabledApproveButton: false,
  cancelButton: "Cancel",
  approveButton: "Approve",
  maxWidth: "600px",
  title: "",
};
